import React from "react"
import { Row, Col } from "reactstrap"
import { FelaComponent } from "react-fela"

import style, { separatorStyle } from "./Info.style"

const Info = props => (
  <FelaComponent style={style}>
    {({ className }) => (
      <React.Fragment>
        <FelaComponent as="hr" style={separatorStyle} />
        <p className="py-3 px-5 text-center">
          Neděláme si iluze, že vše proběhne hladce, ale abychom tomu alespoň
          trochu předešli, věnuj čas těmhle řádkům. Všichni se chceme přece
          hlavně bavit!
          <br />
          Díky ;)
        </p>
        <Row>
          <Col sm={6} className={className}>
            <h3>Ubytování</h3>
            <p>
              Víme, že spánek je důležitý, takže pro tebe máme hned
              2&nbsp;varianty. Vlastní stan (místa bude dost), popř. ti
              doporučíme nejbližší penziony, stačí napsat ;)
            </p>
          </Col>
          <Col sm={6} className={className}>
            <h3>Dorazíš?</h3>
            <p>
              Ty, který jsi mezi pozvanými, dej nám prosím včas vědět, jestli
              dorazíš. Usnadní nám to spoustu plánování.
            </p>
          </Col>
          <Col sm={6} className={className}>
            <h3>Co si přejeme?</h3>
            <p>
              Potěší nás jakýkoliv finanční obnos, který nám usnadní se
              z&nbsp;téhle párty druhý den trochu oklepat.
            </p>
          </Col>
          <Col sm={6} className={className}>
            <h3>Nahoď oblek</h3>
            <p>
              Naší prioritou je hlavně tvoje pohodlí. Jediné co po tobě chceme
              je, aby jsi v tom samém oblečení vydržel celý den. Nazuj klidně
              tenisky, ale havajskou košili a podobný srandy nech pro tentokrát
              na dně skříně. Smart casual rulez :)
            </p>
          </Col>
          <Col sm={6} className={className}>
            <h3>Bezmazlíčkov</h3>
            <p>
              Prostor, kde se svatba koná, není vhodný pro tvého domácího
              mazlíčka (ať už psa, kočku, či anakondu), nech jej doma a užij si
              s&nbsp;námi svatbu.
            </p>
          </Col>
          <Col sm={6} className={className}>
            <h3>Myslíme na všechny</h3>
            <p>
              Co se jídla týče, počítáme se všemi tvými rozmary, ať už jsi
              masožravec nebo vegetarián. A bude toho dost!
            </p>
          </Col>
        </Row>
      </React.Fragment>
    )}
  </FelaComponent>
)

Info.propTypes = {}

export default Info
